import React from "react";
import { useFeedContext } from "./State/FeedContext";
import {
  TypingIndicator,
  TypingIndicatorVariant,
} from "../Icons/TypingIndicator";
import { FeedFilterMobile } from "./FeedFilterMobile";
import { GroopitFeed } from "../GroopitFeed";
import { SuggestedAssignmentNotificationContainer } from "../Groopits/SuggestAssignmentNotificationContainer/SuggestedAssignmentNotificationContainer";

interface FeedPanelProps {
  suggestedAssignmentIds: string[];
}

export const FeedPanel = (props: FeedPanelProps) => {
  const { suggestedAssignmentIds } = props;
  const feed = useFeedContext();

  return (
    <div className="border-app-slateblue lg:border-t-8">
      <div className="border-app-gray-08 border rounded rounded-t-none w-full">
        <div className="hidden lg:flex h-18 border-app-gray-08 border-b w-full px-4 items-center bg-app-slateblue-x-light">
          <div className="text-display-title text-color-secondary">
            <span>Real-time data </span>
            <span className="font-normal">
              (
              {feed.loading ? (
                <TypingIndicator variant={TypingIndicatorVariant.Small} />
              ) : (
                <span>
                  {Intl.NumberFormat([], { notation: "compact" }).format(
                    feed.totalCount,
                  )}
                </span>
              )}
              )
            </span>
          </div>
        </div>
        <div>
          <div className="lg:hidden pl-8 bg-app-teal-x-light text-app-teal border-t-2 border-app-gray-08">
            <FeedFilterMobile />
          </div>
          {suggestedAssignmentIds.length > 0 && (
            <SuggestedAssignmentNotificationContainer
              suggestedAssignmentIds={suggestedAssignmentIds}
              returnUrl={window.location.href}
            />
          )}
          <GroopitFeed />
        </div>
      </div>
    </div>
  );
};
